const PATHS = {
  darkMode: '/dark-mode',
  information: '/information',
  profile: '/profile',
  registration: (id) => `/registrations/${id}`,
  returnToCms: '/',
  trainings: {
    index: '/trainings',
    show: (id) => `/trainings/${id}`,
    instructions: (id) => `/trainings/${id}/instructions`,
    complete: (id) => `/trainings/${id}/complete`,
  },
  courseModuleRegistration: (id) => `/course_module_registrations/${id}`,
  unauthorized: '/unauthorized',
  logout: '/logout',
}

export const API_PATHS = {
  auth: {
    login: '/api/login',
    logout: '/api/logout',
  },
  users: {
    current: '/api/users/current',
    update: (id) => `/api/users/${id}`,
  },
  courseRegistrations: {
    index: '/api/course_module_registrations',
    show: (id) => `/api/course_module_registrations/${id}`,
    update: (id) => `/api/course_module_registrations/${id}`,
  },
  curriculua: {
    index: '/api/curricula',
  },
  certificatesOfCompletion: {
    index: '/api/certificates_of_completion',
  },
  curriculumRegistrations: {
    show: (id) => `/api/curriculum_registrations/${id}`,
    current: (id) => `/api/curriculum_registrations/${id}/current`,
    create: '/api/curriculum_registrations',
  },
  signatureRequests: {
    show: (signatureRequestId) => `/api/signature_requests/${signatureRequestId}`,
    sync: (signatureRequestId) => `/api/signature_requests/${signatureRequestId}/sync`,
    create: `/api/signature_requests`,
  },
  leads: {
    create: '/api/leads',
  },
  states: {
    index: '/api/states',
  },
  curriculumStates: {
    index: '/api/curriculum_states',
  },
}

export const ADMIN_PATHS = {
  completionReports: {
    index: '/admin/completion_reports',
    new: `/admin/completion_reports/new`,
    show: (id) => `/admin/completion_reports/${id}`,
  },
  users: {
    index: '/admin/users',
    show: (id) => `/admin/users/${id}`,
  },
  administrators: {
    index: '/admin/administrators',
  },
  states: {
    index: '/admin/states',
  },
  courses: {
    index: '/admin/courses',
    show: (id) => `/admin/courses/${id}`,
  },
}

export const ADMIN_API_PATHS = {
  administrators: {
    current: '/admin/api/administrators/current',
    index: '/admin/api/administrators',
    enable: (id) => `/admin/api/administrators/${id}/enable`,
    disable: (id) => `/admin/api/administrators/${id}/disable`,
  },
  certificatesOfCompletion: {
    index: (userId) => `/admin/api/users/${userId}/certificates_of_completion`,
  },
  completionReports: {
    index: '/admin/api/completion_reports',
    show: (id) => `/admin/api/completion_reports/${id}`,
    stats: '/admin/api/completion_reports/stats',
    confirmationFile: (id) => `/admin/api/completion_reports/${id}/confirmation_file`,
  },
  courses: {
    index: '/admin/api/courses',
    show: (id) => `/admin/api/courses/${id}`,
  },
  courseStateConfigurations: {
    index: '/admin/api/course_state_configurations',
    show: (id) => `/admin/api/course_state_configurations/${id}`,
  },
  curriculumRegistrations: {
    sendCompletionData: (id) => `/admin/api/curriculum_registrations/${id}/send_completion_data`,
  },
  notes: {
    index: (userId) => `/admin/api/users/${userId}/notes`,
  },
  signatureRequests: {
    index: (userId) => `/admin/api/users/${userId}/signature_requests`,
    destroy: (signatureRequestId) => `/admin/api/signature_requests/${signatureRequestId}/delete`,
  },
  states: {
    index: '/admin/api/states',
    show: (id) => `/admin/api/states/${id}`,
  },
  users: {
    index: '/admin/api/users',
    show: (id) => `/admin/api/users/${id}`,
  },
}
export default PATHS
